module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/parts/b-labeltext1/b-labeltext1.component.css
// module id = ./src/app/parts/b-labeltext1/b-labeltext1.component.css
// module chunks = main